import { Button, Card, Col, message,Row, Space, Typography } from "antd";
import { PermissionAgentRole } from "features/users/components/agent-role/agent-role-permission";
import { AgentSetPermissionList } from "features/users/components/agent-role/agent-set-OperationList";
import { AddRoleAgentModel } from "features/users/components/modals/add-role-agent";
import { useCreatePrivilepermissionRole } from "features/users/use-cases/create-setprivilepermissions";
import { useRoleAgent } from "features/users/use-cases/get-role";
import { ArrowLeft } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

export const AdminManageRoleView = () => {
    const [model, setModel] = useState(false);
    const { data, isFetching, refetch } = useRoleAgent('')
    const [permissions, setPermissions] = useState<any>({});
    const [editdata, setEditData] = useState('')
    const [PrivilegeState, setprivilegestate] = useState<any>('')
    const [roleName, SetRoleName] = useState('')
    const { mutate } = useCreatePrivilepermissionRole()
    const [selectedRoleId, setSelectedRoleId] = useState<number | null>(null);
    const Navigate = useNavigate()
    const handleRevoke = () => {
        if (!PrivilegeState || PrivilegeState.length === 0) {
            message.error("Please select a role first");
            
return;
        }
        const newPermissions: any = {};

        PrivilegeState.forEach((item: any) => {
            newPermissions[item.key] = {
                add: false,
                delete: false,
                update: false,
                view: false,
                print: false,
                enable: false
            };
        });

        // Update UI
        setPermissions(newPermissions);

        // 2) Build payload for API
        const rolePermission = PrivilegeState.map((item: any) => ({
            key: item.key,
            permissions: {
                add: false,
                delete: false,
                edit: false,
                view: false,
                print: false,
                enable: false
            }
        }));

        const payload = {
            roleId: PrivilegeState[0].roleId,
            rolePermission
        };

        // 3) Send revoke-all to API
        mutate(payload, {
            onSuccess: () => message.success("All permissions revoked")
        });

        // 4) Reset selected role UI
        setprivilegestate('');
        SetRoleName('');
        setSelectedRoleId(null);
    };

    const handlePrivilege = () => {
        try {
            if (!PrivilegeState) {
                message.error("Please select a role");

                return;
            }

            const rolePermission = PrivilegeState.map((item: any) => {
                const dynamic = permissions[item.key] || {}; // updated from user
                const original = item.permissions; // original from API

                return {
                    key: item.key,
                    permissions: {
                        add: dynamic.add ?? original.add,
                        delete: dynamic.delete ?? original.delete,
                        edit: dynamic.update ?? original.update,
                        view: dynamic.view ?? original.view,
                        print: dynamic.print ?? original.print,
                        enable: dynamic.enable ?? original.enable
                    }
                };
            });

            const payload = {
                roleId: PrivilegeState[0].roleId,
                rolePermission
            };
            mutate(payload, {
                onSuccess: () => message.success("Privilege updated successfully")
            });

        } catch (error) {
            console.error(error);
        }
    };
    const handleGrantAll = () => {
        if (!PrivilegeState || PrivilegeState.length === 0) {
            message.error("Please select a role first");

            return;
        }

        // 1) Build full true permissions
        const newPermissions: any = {};

        PrivilegeState.forEach((item: any) => {
            newPermissions[item.key] = {
                add: true,
                delete: true,
                update: true,
                view: true,
                print: true,
                enable: true
            };
        });

        // 2) Update UI
        setPermissions(newPermissions);

        // 3) Prepare payload for API
        const rolePermission = PrivilegeState.map((item: any) => ({
            key: item.key,
            permissions: {
                add: true,
                delete: true,
                edit: true,    // update → edit in API
                view: true,
                print: true,
                enable: true
            }
        }));

        const payload = {
            roleId: PrivilegeState[0].roleId,
            rolePermission
        };

        // 4) Call same API
        mutate(payload, {
            onSuccess: () => message.success("All permissions granted successfully")
        });
    };

    return (
        <div >

            <div className="assign_head">
                <button
                    onClick={() => Navigate("/users/agent")}
                    style={{ cursor: "pointer", border: "none", background: "transparent" }}
                >
                    <ArrowLeft size={20} />
                </button>
                <Title level={4} style={{ marginBottom: 0 }}>Assign Role</Title>
            </div>

            <Row gutter={[24, 24]}>
                <Col xs={24} md={8} lg={6}>
                    <Card
                        title="Role List"
                        bordered={false}
                        extra={
                            <Button type="primary" onClick={() => setModel(true)}>
                                Add Role
                            </Button>
                        }
                    >
                        <AgentSetPermissionList
                            itemlist={data}
                            isLoading={isFetching}
                            setEditData={setEditData}
                            setModel={setModel}
                            refetch={refetch}
                            setprivilegestate={setprivilegestate}
                            SetRoleName={SetRoleName}
                            roleName={roleName}
                            setSelectedRoleId={setSelectedRoleId}
                            selectedRoleId={selectedRoleId}

                        />
                    </Card>
                </Col>

                <Col xs={24} md={16} lg={18}>
                    <Card
                        title={roleName || "Set Role & Permissions"}
                        bordered={false}
                        extra={
                            <Space>
                                <Button type="primary" onClick={() => handlePrivilege()}>Save Privilege</Button>
                                <Button onClick={() => handleGrantAll()}>Grant All</Button>
                                <Button danger onClick={handleRevoke}>Revoke</Button>
                            </Space>
                        }
                    >
                        <PermissionAgentRole PrivilegeState={PrivilegeState} setPermissions={setPermissions} permissions={permissions} />
                    </Card>
                </Col>

                {/* MODAL */}
                {model &&
                    <AddRoleAgentModel model={model} setModel={setModel} editdata={editdata} setEditData={setEditData} refetch={refetch} />}
            </Row>
        </div>
    );
};
